interface CopyIconProps {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
}

export default function CopyIcon({
  width = 16,
  height = 16,
  color = "#BFF009",
  className,
}: CopyIconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_45_1455)">
        <path
          d="M5.33334 5.3335V3.46683C5.33334 2.72009 5.33334 2.34672 5.47866 2.06151C5.60649 1.81063 5.81047 1.60665 6.06135 1.47882C6.34656 1.3335 6.71993 1.3335 7.46667 1.3335H12.5333C13.2801 1.3335 13.6534 1.3335 13.9387 1.47882C14.1895 1.60665 14.3935 1.81063 14.5213 2.06151C14.6667 2.34672 14.6667 2.72009 14.6667 3.46683V8.5335C14.6667 9.28023 14.6667 9.6536 14.5213 9.93882C14.3935 10.1897 14.1895 10.3937 13.9387 10.5215C13.6534 10.6668 13.2801 10.6668 12.5333 10.6668H10.6667M3.46667 14.6668H8.53334C9.28007 14.6668 9.65344 14.6668 9.93866 14.5215C10.1895 14.3937 10.3935 14.1897 10.5213 13.9388C10.6667 13.6536 10.6667 13.2802 10.6667 12.5335V7.46683C10.6667 6.72009 10.6667 6.34672 10.5213 6.06151C10.3935 5.81063 10.1895 5.60665 9.93866 5.47882C9.65344 5.3335 9.28007 5.3335 8.53334 5.3335H3.46667C2.71993 5.3335 2.34656 5.3335 2.06135 5.47882C1.81047 5.60665 1.60649 5.81063 1.47866 6.06151C1.33334 6.34672 1.33334 6.72009 1.33334 7.46683V12.5335C1.33334 13.2802 1.33334 13.6536 1.47866 13.9388C1.60649 14.1897 1.81047 14.3937 2.06135 14.5215C2.34656 14.6668 2.71993 14.6668 3.46667 14.6668Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_45_1455">
          <rect width={width} height={height} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
